<template>
  <div class="register-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ pageType=='register' ? $t('breadcrumbs.register') : $t('breadcrumbs.login') }}</span>
    </div>

    <div class="page-title show-on-pad-flex">{{ pageType=='register' ? $t('breadcrumbs.register') : $t('breadcrumbs.login') }}</div>

    <div class="tab show-on-pad-flex">
      <div class="tab-item" :class="{ active: pageType=='register'}" @click="switchPageType">{{ $t('register.register') }}</div>
      <div class="tab-item" :class="{ active: pageType!='register'}" @click="switchPageType">{{ $t('register.login') }}</div>
    </div>

    <div class="cloud-card" :class="{ right:pageType!=='register' }">
      <div class="card-left">
        <div class="title hide-on-pad">{{ $t('register.register') }}</div>
        <div class="form">
          <div class="form-item">
            <div class="item-title required">{{ $t('register.mobile') }}</div>
            <div class="item-content">
              <input type="text" :placeholder="$t('register.register')" v-model="registerData.phone">
            </div>
          </div>
          <div class="form-item">
            <div class="item-title required">{{ $t('register.account_name') }}</div>
            <div class="item-content"><input type="text" :placeholder="$t('register.account_name_placeholder')" v-model="registerData.username"></div>
          </div>
          <div class="form-item">
            <div class="item-title required">{{ $t('register.email') }}</div>
            <div class="item-content"><input type="text" :placeholder="$t('register.email_placeholder')" v-model="registerData.email"></div>
          </div>
          <div class="form-item">
            <div class="item-title required">{{ $t('register.pwd') }}</div>
            <div class="item-content"><input type="text" :placeholder="$t('register.pwd_placeholder')" v-model="registerData.password"></div>
          </div>
          <div class="form-item">
            <div class="item-title required">{{ $t('register.pwd_again') }}</div>
            <div class="item-content"><input type="text" :placeholder="$t('register.pwd_again_placholder')" v-model="registerData.conpassword"></div>
          </div>
          <!-- <div class="form-item">
            <div class="item-title required">验证码</div>
            <div class="item-content">
              <input type="text" placeholder="请输入验证码" v-model="code">
              <div class="btn btn-red get-vertify-code" @click="getCode">领取验证码</div>
            </div>
          </div> -->
          <div class="form-footer">
            <div class="btn btn-orange submit" @click="handleRegister">{{ $t('btns.register') }}</div>
          </div>
        </div>
      </div>
      <div class="card-right">
        <div class="title hide-on-pad">{{ $t('register.login_title') }}</div>
        <div class="form">
          <div class="form-item">
            <div class="item-title">{{ $t('register.account') }}</div>
            <div class="item-content"><input type="text" @keyup.enter="handleLogin" :placeholder="$t('register.account_placeholder')" v-model="loginData.username"></div>
          </div>
          <div class="form-item">
            <div class="item-title">{{ $t('register.pwd') }}</div>
            <div class="item-content"><input type="password" @keyup.enter="handleLogin" :placeholder="$t('register.pwd_placeholder')" v-model="loginData.password"></div>
          </div>
          <div class="form-item remember-block">
            <div class="item-title"></div>
            <div class="item-content justify-between">
              <div class="label-group">
                <input type="checkbox" id="remember" value="yes" v-model="remember"><label for="remember">{{ $t('register.remember') }}</label>
              </div>
              <!-- <a class="forget-pwd hide-on-pad">忘记密码？</a> -->
              <router-link class="forget-pwd hide-on-pad" :to="{ name: 'forget' }">{{ $t('register.forget') }}</router-link>
            </div>
          </div>

          <div class="form-footer flex-column">
            <div class="btn btn-orange submit" @click="handleLogin">{{ $t('btns.login') }}</div>
            <div class="line hide-on-pad"></div>
            <div class="btn btn-green submit" @click="handleWechatLogin"><Icon type="wechat"/>{{ $t('btns.wechat_login') }}</div>
            <!-- <a href="" class="forget-pwd show-on-pad">忘记密码？</a> -->
            <router-link class="forget-pwd show-on-pad" :to="{ name: 'forget' }">{{ $t('register.forget') }}</router-link>
          </div>
        </div>
      </div>
      <div class="card-float-block">
        <p>{{ pageType=='register'?$t('register.login_desc'):$t('register.register_desc') }}</p>
        <div class="btn btn-white login" @click="switchPageType">{{ pageType=='register'?$t('btns.login2'):$t('btns.register2') }}</div>
      </div>
    </div>
    <div class="wx-login-overlay" v-show="showWXloginModal"></div>
    <div class="wx-login-modal" v-show="showWXloginModal">
      <div class="wx-login-close" @click="handleCloseWXlogin">X</div>
      <div id="wx-login-container">

      </div>
    </div>
  </div>
</template>

<script>
import { cloudLoading } from "../../utils/tools.js";
import { registerUser,loginUser,getCode } from '../../api';
import { get } from "../../utils/localStorage";

  export default {
    name: 'register',
    data() {
      return {
        pageType: 'register',
        registerData: {
          phone: '',
          username: '',
          password: '',
          conpassword: '',
          email: '',
          lan : 'cn',
          parentID: ''
        },
        code: '',
        loginData: {
          username: '',
          password: '',
        },
        remember: false,
        showWXloginModal: false
      }
    },
    async created(){
      window.scrollTo({'behavior': 'smooth', 'top': 0})
      const pageType = this.$route.query.type;
      const parent_member_id = this.$route.query.parent_member_id;
      const wzCode = this.$route.query.code;
      this.pageType = pageType || 'register';
      this.registerData.parentID = parent_member_id;

      // 微信登入未拿到的code
      if(wzCode) {
        const res = await wxLogin({ credential: wzCode });
        if(res.status=='ok') {
          console.log('ok');
        }else{
          console.log('no ok');
        }
      }
      
      const rememberAccount = get('account');
      if(rememberAccount) {
        this.loginData.username = rememberAccount;
        this.remember = true;
      }
    },
    mounted() {
      // console.log('register mounted');
      this.$nextTick(() => {
        var obj = new WxLogin({
          self_redirect: false,
          id:"wx-login-container", 
          // appid: "wxb3d5a42fe5c68d3c", 
          appid: "wx06bb94f84d9b2d3a", 
          scope: "snsapi_login", 
          redirect_uri: encodeURI('https://test.e-dwo.com/#/register?type=login'),
          state: "cloud_web",
          // style: "",
          // href: ""
        });
      })
    },
    methods: {
      switchPageType() {
        if(this.pageType == 'register') {
          this.pageType = 'login';
        }else{
          this.pageType = 'register';
        }
      },
      async handleRegister() {
        console.log('this.registerData',this.registerData);
        let isEmpty = false;
        let isEmail = false;
        let isConpassword = false;
        console.log('this.registerData',this.registerData);
        for (const key in this.registerData) {
          console.log('key',key);
          if (this.registerData.hasOwnProperty(key) && key!='parentID') {
            const element = this.registerData[key];
            if(!element) isEmpty = true; 
            if(key=='email') isEmail = element.includes('@');
            if(key=='conpassword') isConpassword = this.registerData.password==this.registerData.conpassword;
          }
        }
        if(isEmpty) {
          this.$message.error(this.$t('alert_message.required'));
          return;
        }
        if(!isEmail) {
          this.$message.error(this.$t('alert_message.email_error'));
          return;
        }
        if(!isConpassword) {
          this.$message.error(this.$t('alert_message.pwd_again_error'));
          return;
        }

        const loading = cloudLoading();
        try {
          const result = await registerUser(this.registerData);
          this.$message({
            message: this.$t('alert_message.register_success'),
            type: 'success'
          });
          this.pageType = 'login';
          const newRegisterData = { ...this.registerData };
          for (const key in newRegisterData) {
            if (newRegisterData.hasOwnProperty(key) && key!='parentID') {
              newRegisterData[key] = '';
            }
          }
          this.registerData = newRegisterData;
        } catch (error) {
          
        }
        loading.close();
        
      },
      async handleLogin() {
        let isEmpty = false;
        for (const key in this.loginData) {
          if (this.loginData.hasOwnProperty(key)) {
            const element = this.loginData[key];
            if(!element) isEmpty = true;
          }
        }
        if(isEmpty) {
          this.$message.error(this.$t('alert_message.inter_acc_pwd')); 
          return;
        }
        
        const loading = cloudLoading();
        try {
          const result = await loginUser(this.loginData,this.remember);
          this.$router.push({ name: 'userCenter' });
        } catch (error) {
          
        }
        loading.close();
      },
      handleWechatLogin() {
        this.showWXloginModal = true;
      },
      handleCloseWXlogin() {
        this.showWXloginModal = false;
      },
    }
  }
</script>

<style lang="less" scoped>
.register-page {
  overflow: hidden;
  .page-title {
    background-image: url('./images/bg_01.png');
    background-size: 100% 100%;
    color: white;
    padding: 34px;
    font-size: 1.5rem;
    justify-content: center;
  }
  .forget-pwd {
    text-decoration: unset;
    color: black;
    @media (max-width: 992px) {
      align-self: center;
      text-decoration: underline;
    }
  }
  .cloud-card {
    width: 80%;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 200px;
    @media (max-width: 992px) {
      box-shadow: unset;
      margin-top: 0;
      margin-bottom: 30px;
      width: 200%;
      transition: 1s;
      .card-right {
        width: 50%;
        padding: 0 20px;
        .form-item {
          margin-bottom: 16px;
        }
        .form-footer {
          .btn {
            margin-bottom: 16px;
            width: 100%;
          }
        }
        
      }
      .card-left {
        width: 50%;
        padding: 0 20px;
      }
      .card-float-block {
        display: none;
      }
      .remember-block {
        margin-top: 40px;
      }
      &.right {
        transform: translateX(-50%);
      }
    }
    
  }
}
.tab {
  padding: 0 50px;
  margin-bottom: 32px;
  .tab-item {
    padding: 18px;
    flex: 1;
    text-align: center;
    &.active {
      border-bottom: 3px solid #FF5214;
    }
  }
}
.cloud-card {
  display: flex;
  box-shadow: 0px 0px 8px #2626264D;
  position: relative;
  .card-left {
    width: 57%;
    padding: 0 42px;
    padding-top: 20px;
    padding-bottom: 50px;
    transition: all .8s .1s;
    .title {
      color: #FF5214;
      text-align: center;
      font-weight: 800;
      font-size: 24px;
      margin: 32px 0;
      padding-left: 80px;
    }
  }
  .card-right {
    width: 43%;
    padding: 0 42px;
    padding-top: 20px;
    padding-bottom: 50px;
    transition: all .8s .1s;
    .title {
      color: #FF5214;
      text-align: center;
      font-weight: 800;
      font-size: 24px;
      margin: 32px 0;
      padding-left: 80px;
    }
    .form-item {
      margin-bottom: 45px;
    }
    .form-footer {
      align-items: flex-end;
      .btn {
        width: calc(100% - 80px);
      }
    }
  }
  .card-float-block {
    background-image: url('./images/bg_01.png');
    background-size: cover;
    position: absolute;
    width: 43%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    transition: 1s;
    left: 57%;
    .login {
      margin-top: 30px;
      width: 67%;
    }
  }
  &.right {
    .card-left {
      width: 43%;
    }
    .card-right {
      width: 57%;
    }
    .card-float-block {
      left: 0%;
    }
    @media (max-width: 992px) {
      .card-left {
        width: 50%;
      }
      .card-right {
        width: 50%;
      }
    }
  }
}

.form {
  .form-item {
    display: flex;
    margin-bottom: 16px;
    @media (max-width: 992px) {
      flex-direction: column;
    }
    .item-title {
      width: 100px;
      position: relative;
      line-height: 28px;
      &.required::before {
        content: '*';
        position: absolute;
        top: 0;
        left: -6px;
        font-size: 12px;
      }
    }
    .item-content {
      display: flex;
      flex: 1;
      &.justify-between {
        justify-content: space-between;
      }
      .get-vertify-code {
        flex: 0 0 50%;
        font-size: 13px;
      }
    }
  }
  .form-footer {
    display: flex;
    justify-content: center;
      margin-top: 40px;
    &.flex-column {
      flex-direction: column;
    }
    .line {
      width: calc(100% - 40px);
      margin: 30px 0;
      height: 1px;
      background: #707070;
    }
    .submit {
      width: 250px;
      @media (max-width: 992px) {
        width: 100%;
      }
      & /deep/ .cloud-icon {
        margin-right: 10px;
        fill: white;
        width: 22px;
        height: 22px;
      }
    }
  }
}
.wx-login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.6);
}
.wx-login-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  background: white;
  border-radius: 10px;
  padding: 20px;
  padding-top: 40px;
  transform: translate(-50%,-50%);
  .wx-login-close {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  #wx-login-container {
    iframe {
      width: 100%;
    }
  }
}
</style>